export default __webpack_public_path__ + "static/media/Bracers of Clawing Might.d74441e7.jpg";